// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/images/stake-rocks.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_wrapper__7HGZl {
  height: 100%;
  display: flex;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat right;
}
@media (max-width: 992px) {
  .styles_wrapper__7HGZl {
    background: none;
  }
}

.styles_inputsBlock__R2nnZ {
  display: flex;
  gap: 24px;
}
@media (max-width: 1200px) {
  .styles_inputsBlock__R2nnZ {
    gap: 12px;
  }
}
@media (max-width: 768px) {
  .styles_inputsBlock__R2nnZ {
    flex-direction: column;
    gap: 8px;
  }
}

.styles_visualBlock__z9zvB {
  margin-top: 19px;
  grid-column-start: 2;
  grid-column-end: 4;
}

.styles_contentWrapper__cbm5D {
  width: 100%;
  padding: 24px;
  grid-column-start: 1;
  display: flex;
  flex-direction: column;
  gap: 24px;
  background: rgba(0, 0, 0, 0.3);
  -webkit-backdrop-filter: blur(50px);
          backdrop-filter: blur(50px);
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 32px;
  transition: all 500ms;
}
@media (max-width: 768px) {
  .styles_contentWrapper__cbm5D {
    gap: 8px;
  }
}

.styles_widthSmall__tGrR7 {
  max-width: calc(100vw - 1044px);
  min-width: 1048px;
}
@media (max-width: 1920px) {
  .styles_widthSmall__tGrR7 {
    max-width: calc(100vw - 870px);
    min-width: unset;
  }
}
@media (max-width: 1700px) {
  .styles_widthSmall__tGrR7 {
    max-width: 100%;
  }
}
@media (max-width: 1400px) {
  .styles_widthSmall__tGrR7 {
    max-width: 100%;
  }
}

.styles_widthFull__C2k3F {
  max-width: calc(100vw - 1044px);
  min-width: 1048px;
}
@media (max-width: 1920px) {
  .styles_widthFull__C2k3F {
    max-width: calc(100vw - 870px);
    min-width: unset;
  }
}
@media (max-width: 1700px) {
  .styles_widthFull__C2k3F {
    max-width: 840px;
  }
}
@media (max-width: 1400px) {
  .styles_widthFull__C2k3F {
    max-width: 100%;
  }
}

.styles_divider__anjzG {
  width: 100%;
  height: 100%;
  padding-left: 24px;
  border-left: 1px dashed rgba(255, 255, 255, 0.05);
}
@media (max-width: 768px) {
  .styles_divider__anjzG {
    padding-left: 0;
    padding: 8px 0;
    border-left: none;
    border-top: 1px dashed rgba(255, 255, 255, 0.05);
    border-bottom: 1px dashed rgba(255, 255, 255, 0.05);
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Stake/content/styles.module.scss","webpack://./src/assets/styles/mixin/breakpoints.scss","webpack://./src/assets/styles/variables/colors.scss"],"names":[],"mappings":"AAGA;EACE,YAAA;EACA,aAAA;EACA,mEAAA;AAFF;ACqBE;EDtBF;IAMI,gBAAA;EADF;AACF;;AAIA;EACE,aAAA;EACA,SAAA;AADF;ACKE;EDNF;IAKI,SAAA;EAAF;AACF;ACYE;EDlBF;IASI,sBAAA;IACA,QAAA;EACF;AACF;;AAEA;EACE,gBAAA;EACA,oBAAA;EACA,kBAAA;AACF;;AAEA;EACE,WAAA;EACA,aAAA;EACA,oBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,8BEvBS;EFwBT,mCAAA;UAAA,2BAAA;EACA,qCAAA;EACA,mBAAA;EACA,qBAAA;AACF;ACdE;EDEF;IAcI,QAAA;EAEF;AACF;;AACA;EACE,+BAAA;EACA,iBAAA;AAEF;ACtDE;EDkDF;IAKI,8BAAA;IACA,gBAAA;EAGF;AACF;ACtDE;ED4CF;IAUI,eAAA;EAIF;AACF;ACrDE;EDsCF;IAcI,eAAA;EAKF;AACF;;AAFA;EACE,+BAAA;EACA,iBAAA;AAKF;AC3EE;EDoEF;IAKI,8BAAA;IACA,gBAAA;EAMF;AACF;AC3EE;ED8DF;IAUI,gBAAA;EAOF;AACF;AC1EE;EDwDF;IAcI,eAAA;EAQF;AACF;;AALA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iDAAA;AAQF;ACpEE;EDwDF;IAOI,eAAA;IACA,cAAA;IACA,iBAAA;IACA,gDAAA;IACA,mDAAA;EASF;AACF","sourcesContent":["@import './src/assets/styles/variables/colors';\n@import './src/assets/styles/mixin/breakpoints';\n\n.wrapper {\n  height: 100%;\n  display: flex;\n  background: url('../../../assets/images/stake-rocks.png') no-repeat right;\n\n  @include lg {\n    background: none;\n  }\n}\n\n.inputsBlock {\n  display: flex;\n  gap: 24px;\n\n  @include xl {\n    gap: 12px;\n  }\n\n  @include md {\n    flex-direction: column;\n    gap: 8px;\n  }\n}\n\n.visualBlock {\n  margin-top: 19px;\n  grid-column-start: 2;\n  grid-column-end: 4;\n}\n\n.contentWrapper {\n  width: 100%;\n  padding: 24px;\n  grid-column-start: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  background: $black-30;\n  backdrop-filter: blur(50px);\n  border: 1px solid $black-15;\n  border-radius: 32px;\n  transition: all 500ms;\n\n  @include md {\n    gap: 8px;\n  }\n}\n\n.widthSmall {\n  max-width: calc(100vw - 1044px);\n  min-width: 1048px;\n\n  @include xxxxl {\n    max-width: calc(100vw - 870px);\n    min-width: unset;\n  }\n\n  @include xxxl {\n    max-width: 100%;\n  }\n\n  @include xxl {\n    max-width: 100%;\n  }\n}\n\n.widthFull {\n  max-width: calc(100vw - 1044px);\n  min-width: 1048px;\n\n  @include xxxxl {\n    max-width: calc(100vw - 870px);\n    min-width: unset;\n  }\n\n  @include xxxl {\n    max-width: 840px;\n  }\n\n  @include xxl {\n    max-width: 100%;\n  }\n}\n\n.divider {\n  width: 100%;\n  height: 100%;\n  padding-left: 24px;\n  border-left: 1px dashed $white-5;\n\n  @include md {\n    padding-left: 0;\n    padding: 8px 0;\n    border-left: none;\n    border-top: 1px dashed $white-5;\n    border-bottom: 1px dashed $white-5;\n  }\n}\n","@mixin xxxxl {\n  @media (max-width: 1920px) {\n    @content;\n  }\n}\n\n@mixin xxxl {\n  @media (max-width: 1700px) {\n    @content;\n  }\n}\n\n@mixin xxl {\n  @media (max-width: 1400px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media (max-width: 1200px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin sm {\n  @media (max-width: 576px) {\n    @content;\n  }\n}\n","$white: #ffffff;\n$white-3: rgba($white, 0.03);\n$white-4: rgba($white, 0.04);\n$white-5: rgba($white, 0.05);\n$white-10: rgba($white, 0.1);\n$white-30: rgba($white, 0.3);\n$white-50: rgba($white, 0.5);\n$white-70: rgba($white, 0.7);\n$white-80: rgba($white, 0.8);\n$white-90: rgba($white, 0.9);\n$pink: #ff136d;\n$pink-10: rgba($pink, 0.1);\n$pink-15: rgba($pink, 0.15);\n$black: #000000;\n$black-5: rgba($black, 0.05);\n$black-15: rgba($black, 0.15);\n$black-26: rgba($black, 0.26);\n$black-30: rgba($black, 0.3);\n$black-70: rgba($black, 0.7);\n$black-87: rgba($black, 0.87);\n$black-bg: #100f0f;\n$black-nav-bg: #080808;\n$black-footer: #0a0a0a;\n$blue: #443de9;\n$blue-btn: #453fd6;\n$blue-btn-15: rgba($blue-btn, 0.15);\n$blue-btn-40: rgba($blue-btn, 0.4);\n$grey-nav: #b6b6b6;\n$grey-input: #414141;\n$orange: #f5b300;\n$orange-5: rgba($orange, 0.05);\n$green: #12bc56;\n$red: #d33030;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `styles_wrapper__7HGZl`,
	"inputsBlock": `styles_inputsBlock__R2nnZ`,
	"visualBlock": `styles_visualBlock__z9zvB`,
	"contentWrapper": `styles_contentWrapper__cbm5D`,
	"widthSmall": `styles_widthSmall__tGrR7`,
	"widthFull": `styles_widthFull__C2k3F`,
	"divider": `styles_divider__anjzG`
};
export default ___CSS_LOADER_EXPORT___;
